"use strict";
/**
 *  @module SDK/API
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestAPI = exports.HTTPMethod = void 0;
var tslib_1 = require("tslib");
var json_bigint_1 = require("@apimatic/json-bigint");
var events_1 = require("events");
var p_timeout_1 = tslib_1.__importDefault(require("p-timeout"));
var query_string_1 = require("query-string");
var constants_js_1 = require("../common/constants.js");
var APIError_js_1 = require("../errors/APIError.js");
var parser_js_1 = require("../errors/parser.js");
var RequestResponseError_js_1 = require("../errors/RequestResponseError.js");
var TimeoutError_js_1 = require("../errors/TimeoutError.js");
var fetch_js_1 = require("../utils/fetch.js");
var object_js_1 = require("../utils/object.js");
var JWT_js_1 = require("./utils/JWT.js");
var payload_js_1 = require("./utils/payload.js");
var HTTPMethod;
(function (HTTPMethod) {
    HTTPMethod["GET"] = "GET";
    HTTPMethod["POST"] = "POST";
    HTTPMethod["PATCH"] = "PATCH";
    HTTPMethod["PUT"] = "PUT";
    HTTPMethod["DELETE"] = "DELETE";
    HTTPMethod["OPTION"] = "OPTION";
    HTTPMethod["HEAD"] = "HEAD";
})(HTTPMethod = exports.HTTPMethod || (exports.HTTPMethod = {}));
var getRequestBody = function (data, keyFormatter) {
    if (keyFormatter === void 0) { keyFormatter = object_js_1.toSnakeCase; }
    return (0, object_js_1.isBlob)(data)
        ? data
        : (0, payload_js_1.containsBinaryData)(data)
            ? (0, payload_js_1.objectToFormData)(data, keyFormatter, ["metadata"])
            : (0, json_bigint_1.stringify)((0, object_js_1.transformKeys)(data, keyFormatter, ["metadata"]));
};
var stringifyParams = function (data) {
    var query = (0, query_string_1.stringify)((0, object_js_1.transformKeys)(data, object_js_1.toSnakeCase), { arrayFormat: "bracket" });
    return query ? "?".concat(query) : "";
};
var execRequest = function (executor, callback) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var response, error_1, err;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, executor()];
            case 1:
                response = _a.sent();
                if (typeof callback === "function") {
                    callback(response);
                }
                return [2 /*return*/, response];
            case 2:
                error_1 = _a.sent();
                err = error_1 instanceof TimeoutError_js_1.TimeoutError ? error_1 : (0, parser_js_1.fromError)(error_1);
                if (typeof callback === "function") {
                    callback(err);
                }
                throw err;
            case 3: return [2 /*return*/];
        }
    });
}); };
var RestAPI = /** @class */ (function (_super) {
    tslib_1.__extends(RestAPI, _super);
    function RestAPI(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this) || this;
        _this._jwtRaw = null;
        _this.handleUpdateJWT = function () { return undefined; };
        _this.endpoint = options.endpoint || process.env[constants_js_1.ENV_KEY_ENDPOINT] || constants_js_1.DEFAULT_ENDPOINT;
        _this.origin = options.origin || _this.origin;
        _this.jwtRaw = options.jwt || process.env[constants_js_1.ENV_KEY_APPLICATION_JWT];
        _this.defaultAuthParams = options.authParams;
        if (options.handleUpdateJWT && typeof options.handleUpdateJWT === "function") {
            _this.handleUpdateJWT = options.handleUpdateJWT;
        }
        _this.appId = options.appId || process.env[constants_js_1.ENV_KEY_APP_ID];
        _this.secret = options.secret || process.env[constants_js_1.ENV_KEY_SECRET];
        _this.authToken = options.authToken;
        return _this;
    }
    Object.defineProperty(RestAPI.prototype, "jwtRaw", {
        get: function () {
            return this._jwtRaw;
        },
        set: function (jwtRaw) {
            this.jwt = (0, JWT_js_1.parseJWT)(jwtRaw);
            this._jwtRaw = jwtRaw;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @internal
     */
    RestAPI.prototype.send = function (method, uri, data, auth, callback, requireAuth, acceptType, keyFormatter, ignoreKeys) {
        if (requireAuth === void 0) { requireAuth = true; }
        if (keyFormatter === void 0) { keyFormatter = object_js_1.toSnakeCase; }
        if (ignoreKeys === void 0) { ignoreKeys = ["metadata"]; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var authParams, dateNow, timestampUTC, payload, params, request;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                authParams = tslib_1.__assign(tslib_1.__assign({}, this.defaultAuthParams), auth);
                dateNow = new Date();
                timestampUTC = Math.round(dateNow.getTime() / 1000);
                if (requireAuth && this._jwtRaw && this.jwt.exp < timestampUTC) {
                    throw new RequestResponseError_js_1.RequestError({
                        code: APIError_js_1.ResponseErrorCode.ExpiredLoginToken,
                        errors: [],
                    });
                }
                payload = [HTTPMethod.GET, HTTPMethod.DELETE].indexOf(method) === -1;
                params = tslib_1.__assign({ headers: this.getHeaders(data, authParams, payload, acceptType), method: method }, ((authParams === null || authParams === void 0 ? void 0 : authParams.useCredentials) ? { credentials: "include" } : {}));
                request = new Request("".concat(this.endpoint).concat(uri).concat(payload ? "" : stringifyParams(data)), payload ? tslib_1.__assign(tslib_1.__assign({}, params), { body: getRequestBody(data, keyFormatter) }) : params);
                this.emit("request", request);
                return [2 /*return*/, execRequest(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var response, jwt, noContentStatus, contentType;
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, fetch(request)];
                                case 1:
                                    response = _a.sent();
                                    this.emit("response", response);
                                    jwt = (0, JWT_js_1.extractJWT)(response);
                                    if (jwt) {
                                        this.jwtRaw = jwt;
                                        this.handleUpdateJWT(jwt);
                                    }
                                    return [4 /*yield*/, (0, fetch_js_1.checkStatus)(response)];
                                case 2:
                                    _a.sent();
                                    noContentStatus = 204;
                                    if (response.status === noContentStatus) {
                                        return [2 /*return*/, ""];
                                    }
                                    contentType = response.headers.get("content-type");
                                    if (contentType === "application/json") {
                                        return [2 /*return*/, (0, fetch_js_1.parseJSON)(response, ignoreKeys)];
                                    }
                                    else if (contentType) {
                                        if (contentType.indexOf("text/") === 0) {
                                            return [2 /*return*/, response.text()];
                                        }
                                        else if (contentType.indexOf("multipart/") === 0) {
                                            return [2 /*return*/, response.formData()];
                                        }
                                    }
                                    return [2 /*return*/, response.blob()];
                            }
                        });
                    }); }, callback)];
            });
        });
    };
    RestAPI.prototype.getHeaders = function (data, auth, payload, acceptType) {
        if (acceptType === void 0) { acceptType = "application/json"; }
        var headers = new Headers();
        var isFormData = (0, payload_js_1.containsBinaryData)(data);
        headers.append("Accept", acceptType);
        if (!isFormData && payload) {
            headers.append("Content-Type", "application/json");
        }
        var _a = auth || {}, _b = _a.origin, origin = _b === void 0 ? this.origin : _b, _c = _a.idempotentKey, idempotentKey = _c === void 0 ? null : _c, _d = _a.authToken, authToken = _d === void 0 ? this.authToken : _d, _e = _a.appId, appId = _e === void 0 ? this.appId : _e, _f = _a.secret, secret = _f === void 0 ? this.secret : _f, _g = _a.jwt, jwt = _g === void 0 ? this.jwtRaw : _g, headerOverrides = _a.headers;
        if (headerOverrides) {
            Object.keys(headerOverrides).forEach(function (key) { return headers.append(key, headerOverrides[key]); });
        }
        if (origin) {
            headers.append("Origin", origin);
        }
        if (idempotentKey) {
            headers.append(constants_js_1.IDEMPOTENCY_KEY_HEADER, idempotentKey);
        }
        if (authToken) {
            headers.append("Authorization", "Token ".concat(authToken));
        }
        else if (appId) {
            headers.append("Authorization", "ApplicationToken ".concat(appId, "|").concat(secret || ""));
        }
        else if (jwt) {
            if (secret) {
                headers.append("Authorization", "Bearer ".concat(secret, ".").concat(jwt));
            }
            else {
                headers.append("Authorization", "Bearer ".concat(jwt));
            }
        }
        return headers;
    };
    /**
     * @internal
     */
    RestAPI.prototype.longPolling = function (
    /**
     * API call to be repeated
     */
    promise, 
    /**
     * Condition for which the response is considered to be successful and stop the polling
     */
    successCondition, 
    /**
     * Condition to cancel the polling without triggering error
     */
    cancelCondition, 
    /**
     * Callback to be triggered at the end of the long polling
     */
    callback, 
    /**
     * Time after which a TimeoutError will be triggered and the poll will be canceled
     */
    timeout, 
    /**
     * Interval between polls
     */
    interval, 
    /**
     * Callback to be triggered at each poll iteration
     */
    iterationCallback) {
        if (timeout === void 0) { timeout = constants_js_1.POLLING_TIMEOUT; }
        if (interval === void 0) { interval = constants_js_1.POLLING_INTERVAL; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, execRequest(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var repeater;
                        var _this = this;
                        return tslib_1.__generator(this, function (_a) {
                            repeater = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var result;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, promise()];
                                        case 1:
                                            result = _a.sent();
                                            iterationCallback === null || iterationCallback === void 0 ? void 0 : iterationCallback(result);
                                            if (cancelCondition === null || cancelCondition === void 0 ? void 0 : cancelCondition(result)) {
                                                return [2 /*return*/, null];
                                            }
                                            if (!!successCondition(result)) return [3 /*break*/, 3];
                                            return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, interval); })];
                                        case 2:
                                            _a.sent(); // sleep to avoid firing requests too fast
                                            return [2 /*return*/, repeater()];
                                        case 3: return [2 /*return*/, result];
                                    }
                                });
                            }); };
                            return [2 /*return*/, (0, p_timeout_1.default)(repeater(), timeout, new TimeoutError_js_1.TimeoutError(timeout))];
                        });
                    }); }, callback)];
            });
        });
    };
    RestAPI.prototype.ping = function (callback) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.send(HTTPMethod.GET, "/heartbeat", null, null, callback, false)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return RestAPI;
}(events_1.EventEmitter));
exports.RestAPI = RestAPI;
//# sourceMappingURL=RestAPI.js.map